import type {
  LandingDetailedSerializer,
  IApiResponse,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export const landingsApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getLanding: build.query<
      LandingDetailedSerializer,
      { slug: string; previewKey?: string | null }
    >({
      query({ slug, previewKey }) {
        return {
          url: previewKey
            ? `/foundation/api/landings/${slug}?preview_key=${previewKey}`
            : `/foundation/api/landings/${slug}`,
          method: "GET",
        };
      },
      transformResponse: (
        response: IApiResponse<LandingDetailedSerializer>
      ) => {
        return response.payload.data;
      },
    }),
  }),
});
